import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";
import productsData from "../db/store.json";
import Header from "./Header";
const categories = [{name:'All',image:"https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100" }, {name:"men's clothing",image:"https://fakestoreapi.com/img/71-3HjGNDUL._AC_SY879._SX._UX._SY._UY_.jpg" },{name:"women's clothing",image:"https://fakestoreapi.com/img/61pHAEJ4NML._AC_UX679_.jpg"},{name:"jewelery",image:"https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_.jpg"} ,{name:"electronics",image:"https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg"}  ]

function ProductListing() {

  const [selectCategory,setSelectCategory] = React.useState('All')
  return (
    <>
       <Header></Header>
          <div>
<div className="Categories" style={{display:'flex',flexDirection:'row',justifyContent:'space-around',paddingInline:"2%",marginTop:10,
    borderBottomStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ddd',
    paddingBottom: 10   }}>
  {categories.map((category,index) =>{

    return(
      <div key={index} style={{display:'flex',flexDirection:'column',alignItems:'center' }} onClick={() =>{setSelectCategory(category.name); console.log(selectCategory) } }> 
      <img src={category.image}   style={{height:50,width:40,objectFit:'cover' }} />
     <p style={{marginBlock:5,fontWeight:'500',fontSize:12}}> {category.name}</p>
      
      </div>
    )
  } )}
</div>

    <div
      className="Product_Listing"
      style={{
        padding: 20,
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
      }}
    >
      {productsData.map((product, index) => {
        if(selectCategory=='All')
        {
        return (
          <ProductCard
            key={index}
            name={product.title}
            price={product.price}
            image={product.image}
            id={product.id}
          />
        )
        }
        else{
          if(selectCategory === product.category)
          {
              return (
          <ProductCard
            key={index}
            name={product.title}
            price={product.price}
            image={product.image}
            id={product.id}
          />
        )
          }
        }
      })}{" "}
    </div>
    </div>
    </>
 
  );
}

export default ProductListing;
